import {bindable, customElement, inject} from 'aurelia-framework';
import {EventAggregator} from 'aurelia-event-aggregator';

@customElement('sio-form-row')
@inject(EventAggregator)

export class FormRow
{
    @bindable field;

    constructor(ea) {
        this.ea = ea;
        this.allowedFields = [
            // accommodation
            {
                property: 'accommodation',
                tooltip: 'Inhalt für alle Tage kopieren',
            },
            {
                property: 'accommodationAdditionalText',
                tooltip: 'Inhalt für alle Tage kopieren',
            },
            // itinerary flight
            {
                property: 'deviatingEndingAirport',
                tooltip: 'tourism-journey.copy.deviatingEndingAirport.tooltip',
                copyFrom: 'deviatingStartingAirport',
            },
            {
                property: 'deviatingStartingAirport',
                tooltip: 'tourism-journey.copy.deviatingStartingAirport.tooltip',
                copyFrom: 'deviatingEndingAirport',
            },
        ];
    }

    get showPasteButton() {
        return Boolean(this.copyConfig);
    }

    get copyConfig() {
        if (!this.field) {
            return null;
        }

        return this.allowedFields.find(
            (allowedField) => allowedField.property === this.field.property
        );
    }

    get copyFieldTooltip() {
        return this.copyConfig?.tooltip;
    }

    handleCopyFieldData() {
        const config = this.copyConfig;

        if (config?.copyFrom && this.field?.parent?.getFieldByProperty) {
            const sourceField = this.field.parent.getFieldByProperty(config.copyFrom);

            if (!sourceField) {
                return;
            }

            this.field.setValue(sourceField.getValue()).valueChanged();
        } else {
            this.ea.publish('sio_fieldValueListner', this.field);
        }
    }
}
